import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";

const BreadcrumbsComponent = ({ breadcrumbs }) => {
  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="›" aria-label="breadcrumb" sx={{ fontSize: "14px" }}>
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
};

export default BreadcrumbsComponent;
